import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { GlobalsService } from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-private-policy-template-sheet',
  templateUrl: './private-policy-template-sheet.component.html',
  styleUrls: ['./private-policy-template-sheet.component.scss']
})
export class PrivatePolicyTemplateSheetComponent implements OnInit {
  public sys: string;
  public lottoSubs: Subscription;

  constructor(private _bottomSheetRef: MatBottomSheetRef<PrivatePolicyTemplateSheetComponent>, private _globals: GlobalsService) {}

  closeTerminsAndConditions(): void {
    this._bottomSheetRef.dismiss();
  }

  ngOnInit(): void {
    this.setSysAndLang();
  }

  setSysAndLang(): void {
    this.sys = this._globals.getSystem().site;
  }
}
